import { ESqlOperators } from 'scw-digital-boards-widgets';
import { EValueType } from '../../../../shared/components/advanced-filter/advanced-filter-fields.constants';

export enum EParamLocation {
  query = 'query',
  body = 'body',
  header = 'header',
}

export enum EDatePart {
  range = 'range',
  start = 'start',
  end = 'end',
}

export enum EShiftOutput {
  shiftDay = 'shiftDay',
  shiftTimes = 'shiftTimes',
  shift = 'shift',
}

/**
 * dayjs tokens offered for a date tag, grouped by separator and ordered year / day / month first inside each
 * group. Date-only on purpose: a filter value is a calendar date, so it cannot be turned into a correct
 * timestamp without knowing the receiving system's timezone.
 */
export const ENDPOINT_PARAMETER_DATE_FORMATS: readonly string[] = [
  'YYYY-MM-DD',
  'DD-MM-YYYY',
  'MM-DD-YYYY',
  'YYYY/MM/DD',
  'DD/MM/YYYY',
  'MM/DD/YYYY',
  'YYYY.MM.DD',
  'DD.MM.YYYY',
  'MM.DD.YYYY',
  'YYYYMMDD',
];

export const [DEFAULT_ENDPOINT_PARAMETER_DATE_FORMAT] = ENDPOINT_PARAMETER_DATE_FORMATS;

/**
 * Same token set as `ENDPOINT_PARAMETER_DATE_FORMATS`, with a time-of-day appended. Only offered for
 * `shiftOutput: shiftTimes` — unlike a plain date filter value, a shift's start/end already comes back from
 * the OEE Tracker as a concrete timestamp, so there's no timezone ambiguity in formatting it with a time part.
 */
export const ENDPOINT_PARAMETER_DATETIME_FORMATS: readonly string[] = [
  'YYYY-MM-DD HH:mm:ss',
  'DD-MM-YYYY HH:mm:ss',
  'MM-DD-YYYY HH:mm:ss',
  'YYYY/MM/DD HH:mm:ss',
  'DD/MM/YYYY HH:mm:ss',
  'MM/DD/YYYY HH:mm:ss',
  'YYYY.MM.DD HH:mm:ss',
  'DD.MM.YYYY HH:mm:ss',
  'MM.DD.YYYY HH:mm:ss',
  'YYYYMMDDHHmmss',
];

export const [DEFAULT_ENDPOINT_PARAMETER_DATETIME_FORMAT] = ENDPOINT_PARAMETER_DATETIME_FORMATS;

export interface IUrlParamsTemplateTag {
  id: number;
  templateId: number;
  tag: string;
  field: string;
  operator: ESqlOperators | string;
  splitBy: string | null;
  isRequired: boolean;
  valueType: EValueType;
  valuePrefix: string | null;
  valueSuffix: string | null;
  dateFormat: string | null;
  datePart: EDatePart | null;
  shiftOutput: EShiftOutput | null;
}

export interface IUrlParamsTemplate {
  id: number;
  client?: string;
  workspaceId: number;
  workspace?: { id: number; name: string };
  name: string;
  paramLocation: EParamLocation;
  key: string;
  queryTemplate: string;
  tags: IUrlParamsTemplateTag[];
}

export interface IEndpointParameterDatatableRow {
  id: number;
  name: string;
  workspace: string;
  paramLocation: EParamLocation;
  key: string;
}

export interface IUrlParamsTemplateTagPayload {
  tag: string;
  field: string;
  operator: ESqlOperators | string;
  splitBy: string | null;
  isRequired: boolean;
  valueType: EValueType;
  valuePrefix: string | null;
  valueSuffix: string | null;
  dateFormat: string | null;
  datePart: EDatePart | null;
  shiftOutput: EShiftOutput | null;
}

export interface IUrlParamsTemplateAddPayload {
  workspaceId: number;
  name: string;
  paramLocation: EParamLocation;
  key: string;
  queryTemplate: string;
  tags: IUrlParamsTemplateTagPayload[];
}

export interface IUrlParamsTemplateEditPayload {
  id: number;
  dto: IUrlParamsTemplateAddPayload;
}
